export default __webpack_public_path__ + "static/media/wellDone.4abf61f6.svg";